import { useMutation } from '@tanstack/react-query'
import { useAtom } from 'jotai'
import { RESET } from 'jotai/utils'
import { insiConsultSerializer } from '../../../../misc/insi.utilities'
import { InsiIdentityCheckPayload,   InsiResponsePatient } from '../../../../model/Insi'
import { insiConsultRequestAtom } from '../../../../state/insi'
import type { InsCheckTypeValue } from '../../../../features/ins/types/ins.types'

interface UseInsiConsultIdentityCheckVariables {
  patient: InsiIdentityCheckPayload | null
  type?: InsCheckTypeValue
}

interface InsiConsultIdentityCheckVariablesError {
  error: Error
  type?: InsCheckTypeValue
}

export const useInsiConsultIdentityCheck = () => {
  const [, setInsiConsultRequest] = useAtom(insiConsultRequestAtom)

  const mutation = useMutation<
    InsiResponsePatient | null,
    InsiConsultIdentityCheckVariablesError,
    UseInsiConsultIdentityCheckVariables
  >({
    mutationFn: async ({ patient, type }) => {
      const promise = new Promise<InsiResponsePatient | null>((resolve, reject) => {
        setInsiConsultRequest({
          search: patient ? insiConsultSerializer(patient) : null,
          onReceivePatient: (patient: InsiResponsePatient | null) => {
            resolve(patient)
          },
          onError: (error: any) => {
            reject({
              ...error,
              type,
            })
          },
        })
      })

      const response = await promise


      return response
    },
    onSettled: () => {
      setInsiConsultRequest(RESET)
    },
  })

  return mutation
}
